<div class="d-flex justify-content-between">
    <h2 mat-dialog-title>Edit Document</h2>
    <button color="primary" mat-icon-button [mat-dialog-close]="false">
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content>
    <form [formGroup]="ediDocumentForm" class="inputs-container">
        <mat-form-field appearance="outline">
            <mat-label>Document Name</mat-label>
            <input type="text" matInput formControlName="document_name" placeholder="Document Name">
            <mat-error *ngIf="isFieldHasRequiredError('document_name')">Document name is
                required</mat-error>
        </mat-form-field>

        <app-tags-autocomplete [tags]="allAvailableTags" [defaultTags]="defaultTags"
            [config]="data.options.tagsAutocompleteOptions"
            (change)="onSelectedTagsChanged($event)"></app-tags-autocomplete>

        <mat-form-field appearance="outline" *ngIf="this.data.options.showExpiryDateColumn">
            <mat-label>Expiry Date</mat-label>
            <input matInput [matDatepicker]="picker2" formControlName="expiry_date">
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2 color="primary"></mat-datepicker>
        </mat-form-field>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="center" class="mm-mt-5 mm-mb-3">
    <button mat-flat-button color="primary" [disabled]="ediDocumentForm.invalid || loading" class="upload-btn"
        (click)="saveDocument()"> <span *ngIf="!loading">Save</span>
        <span *ngIf="loading">Saving, please wait...</span>
    </button>
</mat-dialog-actions>